import ModalAddEditBenchmark from "./modal-add-edit-benchmark";

export default ModalAddEditBenchmark;